export function getAccountId(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const accountIdFromUrl = urlParams.get('account_id')

  if (accountIdFromUrl && accountIdFromUrl !== '') {
    return accountIdFromUrl
  }

  // Check DOM attributes
  const wpElement = document.getElementById('jellybeans-admin-ui')
  const accountIdFromElement = wpElement?.getAttribute('data-account-id')

  if (accountIdFromElement && accountIdFromElement !== '') {
    return accountIdFromElement
  }

  return ''
}

export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0] // Returns YYYY-MM-DD
}


export const storeDataInSessionStorage = (key: string, data: string) => {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export const getDataFromSessionStorage = (key: string): string => {
  const data = sessionStorage.getItem(key)
  return data ? JSON.parse(data) : null
}
